import React from 'react';

import Container from '@material-ui/core/Container';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import Layout from 'components/Layout';
import Background from 'components/Layout/Background';

// TODO: dictionary/other langs - i18n doesn't work here

const BackendDown: React.FC = () => {
  return (
    <Layout title={'Omlouváme se, zaznamenali jsme výpadek aplikace. Zkuste se přihlásit za chvíli.'}>
      <Background>
        <Container maxWidth="md" style={{ textAlign: 'center' }}>
          <Typography variant="h3">{'Omlouváme se, zaznamenali jsme výpadek aplikace. Zkuste se přihlásit za chvíli.'}</Typography>
          <Typography>
            <Button variant="contained" color="primary" onClick={() => window.location.reload()}>
              {'Obnovit stránku'}
            </Button>
          </Typography>
        </Container>
      </Background>
    </Layout>
  );
};

export default BackendDown;
